import { render, staticRenderFns } from "./BaseRadioSwitch.vue?vue&type=template&id=cc693b3e&scoped=true&"
import script from "./BaseRadioSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseRadioSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../registration-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc693b3e",
  null
  
)

export default component.exports